import { Link } from 'react-router-dom';
import { kbSections } from '@/mocks/knowledgeBase';

const indexItems = [
  ...kbSections.map((section) => ({
    slug: section.slug,
    title: section.title,
    icon: section.icon,
  })),
  { slug: 'official-links', title: 'Official Gracie & Lily Links', icon: 'ri-links-line' },
  { slug: 'faq', title: 'Frequently Asked Questions', icon: 'ri-question-answer-line' },
];

/**
 * Anchor index shown at the top of the full Knowledge Base page so visitors
 * (and crawlers) can jump straight to any of the 12 sections.
 */
export default function SectionIndex() {
  return (
    <nav
      aria-label="Knowledge Base sections"
      className="mt-8 rounded-2xl border border-background-200 bg-white p-4 md:p-5"
    >
      <div className="flex items-center gap-2 mb-3">
        <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-list-check text-base"></i>
        </span>
        <h2 className="text-xs md:text-sm font-extrabold uppercase tracking-widest text-foreground-700">
          Jump to a section
        </h2>
      </div>
      <ul className="flex flex-wrap gap-2">
        {indexItems.map((item, index) => (
          <li key={item.slug}>
            <Link
              to={`/knowledge-base#${item.slug}`}
              className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs md:text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <span className="text-[11px] font-black text-primary-500">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="w-4 h-4 flex items-center justify-center text-foreground-500">
                <i className={`${item.icon} text-sm`}></i>
              </span>
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}